'use es6';

export const getAppIntegrations = state => state.appIntegrations;